import React from "react"
import { Outlet } from "react-router-dom"
import LearnHeader from "./LearnHeader"

/**
 * Shell for the signed-in part of the lecture portal: the portal's own header
 * plus an outlet for the active page. Deliberately light -- the portal is a
 * focused, read-only experience, so there is no sidebar to maintain at small
 * breakpoints.
 */
export default function LearnLayout() {
    return (
        <div className="flex min-h-screen flex-col bg-slate-50">
            <LearnHeader />

            <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6 sm:px-6 sm:py-8">
                <Outlet />
            </main>

            <footer className="border-t border-slate-200 bg-white px-4 py-4 text-center text-xs text-slate-400">
                School Management · Lecture Portal
            </footer>
        </div>
    )
}
